import React, { useState } from "react";
import LeftNavMenuItem from "./LeftNavMenuItem";
import LeftNavLink from "./LeftNavLink";

export default function LeftNavMenu(props) {
  const { item, insideRouter, isActive, submenuName } = props;
  const reportGroup = window.adminPortalReportGroup;

  let subitems = null;
  if (item.subitems && item.subitems.length) {
    subitems = item.subitems.map((el, idx) => (
      <LeftNavMenuItem
        key={idx}
        item={el}
        insideRouter={insideRouter}
        isActive={
          submenuName === el.label || (reportGroup && reportGroup === el.elementId)
        }
        isSubitem={true}
      ></LeftNavMenuItem>
    ));
  }
  const className = subitems ? "arrow" : "selected";
  return (
    <li className={isActive ? "start active" : ""}>
      {subitems ? (
        <React.Fragment>
          <a>
            <i className={item.iconClass}></i>
            <span className="title">{item.label}</span>
            <span className={className} />
          </a>
          {!subitems ? null : <ul className="sub-menu">{subitems}</ul>}
        </React.Fragment>
      ) : (
        <LeftNavLink item={item} insideRouter={insideRouter}>
          <i className={item.iconClass}></i>
          <span className="title">{item.label}</span>
          <span className={className} />
        </LeftNavLink>
      )}
    </li>
  );
}
